import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";
import { Window } from "@progress/kendo-react-dialogs";
import CommonInput from "../../../components/sys-common/CommonInput";
import ParticipantService from "../../../services/srv-participants/ParticipantService";
import { useEffect, useState } from "react";
import { Upload } from "@progress/kendo-react-upload";
import CommonDropDownList from "../../../components/sys-common/CommonDropDownList";
import { API_GATEWAY, PR_DEP } from "../../../config/globalVariables";
import LoadingPanel from "../../../components/sys-toolbox/LoadingPanel";
import TemplateService from "../../../services/srv-mailTemplate/TemplateService";
import CommonEditor from "../../../components/sys-common/CommonEditor";
import CommonMultiSelect from "../../../components/sys-common/CommonMultiSelect";
import EtkinlikMailService from "../../../services/srv-etkinlikMail/EtkinlikMailService";
import { getAllMailTemplateParameters } from "../../../utils/common";

export const ParticipantSendReminderMail = (props) => {
  const fetchTemplateUrl = `${
    API_GATEWAY + PR_DEP
  }/mailtemplate/get-list-valid`;
  const { t } = useTranslation();
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [participants, setParticipants] = useState([]);
  const [participantItems, setParticipantItems] = useState([]);
  const [latestTemplate, setLatestTemplate] = useState(false);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    EtkinlikMailService.getLatestMailBody(
      props.event.etkinliK_TANIM_ID,
      "MAIL"
    ).then((data) => {
      setBody(data?.data?.soN_GONDERILEN_SABLON);
      setLatestTemplate(!!data?.data?.soN_GONDERILEN_SABLON);
    });
  }, []);

  useEffect(() => {
    if (!props.dataState) {
      return;
    }

    const reminderDataState = {
      ...props.dataState,
      filter: {
        logic: "and",
        filters: [
          ...(props.dataState.filter ? [props.dataState.filter] : []),
          {
            field: "maiL_GONDERILDI",
            operator: "eq",
            value: "EVET",
          },
        ],
      },
    };

    setLoading(true);
    ParticipantService.getParticipantsForExcel(reminderDataState)
      .then((result) => {
        const list = Array.isArray(result?.data) ? result.data : [];
        setParticipantItems(list);
        setParticipants(list);
      })
      .catch(() => {
        setParticipantItems([]);
        setParticipants([]);
      })
      .finally(() => setLoading(false));
  }, [props.dataState]);

  const sendMail = () => {
    setLoading(true);
    const formData = new FormData();

    uploadedFiles.forEach((file) => {
      formData.append("AttachmentList", file.rawFile, file.name);
    });

    formData.append("subject", subject);
    formData.append("body", body);
    formData.append(
      "participants",
      participants.map((p) => p.email)
    );
    formData.append("etkinlik_tanim_id", props.event.etkinliK_TANIM_ID);

    ParticipantService.sendReminderailToParticipants(formData).then((data) => {
      setLoading(false);
      props.setIsAdded(true);
      props.toggleDialog();
    });
  };

  const onAdd = (event) => {
    const newFiles = event.affectedFiles.map((file) => ({
      name: file.name,
      rawFile: file.getRawFile(), // Dosyanın binary içerik verisi
    }));
    setUploadedFiles([...uploadedFiles, ...newFiles]);
  };

  const onRemove = (event) => {
    const removedFile = event.affectedFiles[0];
    setUploadedFiles(uploadedFiles.filter((f) => f.name !== removedFile.name));
  };

  const onChangeTemplate = (e) => {
    setLoading(true);
    TemplateService.getTemplate(e.target.value.id).then((data) => {
      setBody(data?.data?.body);
      setLoading(false);
    });
  };

  const allParameters = getAllMailTemplateParameters();

  return (
    <Window
      title={props.title}
      onClose={props.toggleDialog}
      stage={window.innerWidth < 1000 ? "FULLSCREEN" : "DEFAULT"}
      initialHeight={"80vh"}
      initialWidth={"60%"}
      style={{
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        position: "fixed",
        zIndex: 10000,
      }}
    >
      {loading && <LoadingPanel />}
      <CommonMultiSelect
        key={`reminder-recipients-${participantItems.length}`}
        id="participants"
        label={t("mail_recipients")}
        valueField="email"
        textField="fullname"
        items={participantItems}
        onChange={(e) => setParticipants(e.value)}
        selectAll={true}
        required={true}
      ></CommonMultiSelect>
      <CommonInput
        id="baslik"
        label={t("mail_subject")}
        required={true}
        onChange={(e) => setSubject(e.value)}
        value={subject}
      ></CommonInput>
      <CommonDropDownList
        id="maiL_TEMPLATE"
        label={
          latestTemplate === true
            ? t("last_sent_template")
            : t("choose_template")
        }
        valueField="code"
        textField="code"
        onChange={onChangeTemplate}
        fetchUrl={fetchTemplateUrl}
      ></CommonDropDownList>
      {body && (
        <>
          <CommonEditor
            value={body}
            onChange={(e) => setBody(e.html)}
          ></CommonEditor>

          {allParameters.length > 0 && (
            <div className="template-parameters mt-3 mb-3">
              <h6>{t("parameters")}</h6>
              <div className="parameter-list p-2 bg-light border rounded">
                {allParameters.map((param, index) => (
                  <span key={index} className="parameter-item">
                    <code>#{param}#</code>:{" "}
                    {t(`mail_template_parameters.${param}`)}
                    {index < allParameters.length - 1 && ", "}
                  </span>
                ))}
              </div>
            </div>
          )}
        </>
      )}
      <hr></hr>
      <h4>{t("mail_attachments")}</h4>
      <Upload
        files={uploadedFiles}
        multiple={true}
        onAdd={onAdd}
        onRemove={onRemove}
      />
      <hr></hr>
      <Button
        color="primary"
        type="button"
        size="sm"
        onClick={sendMail}
        disabled={loading}
      >
        <i className="fa fa-edit"></i> {loading ? t("sending") : t("send_mail")}
      </Button>
    </Window>
  );
};
